import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const TravelCountrySlice = createSlice({
  name: "TravelCountry",
  initialState,
  reducers: {
    TravelCountryStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    TravelCountrySuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    TravelCountryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  TravelCountryStart,
  TravelCountrySuccess,
  TravelCountryFailure,
  clearError,
  clearMessage,
} = TravelCountrySlice.actions;

export default TravelCountrySlice.reducer;
